import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import useTheme from "@mui/material/styles/useTheme";

import type { NewPatientSeed } from "./new-patient-seed.utils";
import { describeNewPatientSeed } from "./new-patient-seed.utils";

type AddNewPatientOptionProps = {
  renderProps?: React.HTMLAttributes<HTMLLIElement>;
  seed: NewPatientSeed;
};

/**
 * The one row offered when a search comes back empty. Rendered as an action — icon,
 * verb-first label, and a line stating what gets carried into the form — so it never
 * reads as a patient record.
 */
export default function AddNewPatientOption({
  renderProps,
  seed
}: AddNewPatientOptionProps) {
  const theme = useTheme();
  const { primary, secondary } = describeNewPatientSeed(seed);

  return (
    <ListItem
      {...renderProps}
      data-testid="patient-search-add-new-patient"
      sx={{
        "&.MuiAutocomplete-option.Mui-focused": {
          bgcolor: theme.palette.patientSearch.bgcolor
        }
      }}
    >
      <ListItemIcon sx={{ minWidth: 40 }}>
        <PersonAddAltOutlinedIcon color="primary" />
      </ListItemIcon>
      <ListItemText
        primary={primary}
        secondary={secondary}
        primaryTypographyProps={{
          color: "primary.main",
          component: "div",
          fontWeight: "fontWeightBold"
        }}
        secondaryTypographyProps={{
          component: "div",
          variant: "caption"
        }}
      />
    </ListItem>
  );
}
